module.exports = __webpack_public_path__ + "img/uz.d5e5f9cd.svg";